import React, { useState, forwardRef,useEffect , useImperativeHandle, useRef} from 'react';
import axios from "axios";
import { Modal } from 'react-bootstrap';

const CreateVehicleRepairRecord  = forwardRef((props, ref) => {
  const [inviteModal, setInviteModal] = useState(false);
  useImperativeHandle(ref, () => ({
    showInviteModal() {
      setInviteModal(true);
    }
  }));
  console.log('props.data',props.data)

  const userdata = localStorage.getItem('USER_data');
  const userData = JSON.parse(userdata);
  const userid = userData.id;
    const [formData, setFormData] = useState({
        RepairOrderID:props.data.RepairOrderID,
        VehicleID: props.data.VehicleID,
        CustomerID:  props.data.CustomerID,
        RepairDate: props.data.RepairDate,
       // RepairStatus: '',
       // TechnicianID: '',
       // LaborHours: '',
       // ServiceCost: '',
       // Notes: '',
       // PartQuantities: '',
       // PartCost: '',
      });
  const [completedRepairs, setCompletedRepairs] = useState([]);
  const [allServices, setAllServices] = useState([]);
  const [selectedRepair, setSelectedRepair] = useState(null);
  const [selectedServices, setSelectedServices] = useState([]);
  const [nextDate, setNextDate] = useState("");
  const [intervalMonths, setIntervalMonths] = useState("");
  const [intervalKm, setIntervalKm] = useState("");
  const [loading, setLoading] = useState(false);
const fetchCategories = async () => {
    try {
        const response = await axios.get('https://subk.education.com.ly/back/api/getServiceCategory'); // Adjust to your actual API URL
        setCategories(response.data);
    } catch (error) {
        console.error('Error fetching categories:', error);
    }
};
  
//   // Fetch all services
    useEffect(() => {
fetchCategories()   }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (  selectedService.length === 0 || !nextDate) {
      alert("Please select a repair, at least one service, and a next maintenance date.");
      return;
    }

    try {
      setLoading(true);
    //   const payload = {
    //     VehicleID: selectedRepair.vehicle_id,
    //    // LastRepairOrderID: selectedRepair.RepairOrderID,
    //     NextDate: nextDate,
    //     IntervalMonths: intervalMonths || null,
    //     IntervalKm: intervalKm || null,
    //     Services: selectedServices, // array of ServiceID
    //   };
const payload = {
  // other fields of your repair order
    VehicleID: props.data.VehicleID,
LastRepairOrderID: props.data.RepairOrderID,
    NextDate: nextDate,
     IntervalMonths: intervalMonths || null,
        IntervalKm: intervalKm || null,
  UserID:userid,
  // Initialize repairDetails as a list of selected services
  repairDetails: [
    ...selectedService.map(service => ({
      RepairOrderID: props.data.RepairOrderID,
      ServiceID: service.ServiceID,
     
      Status: "قيد الانتظار", // optional default status
    }))
  ]
};
console.log('payload',payload)
      await axios.post("https://subk.education.com.ly/back/api/storeScheduledMaintenance", payload);

      alert("Next maintenance scheduled successfully!");
      // Reset form
      setSelectedRepair(null);
      setNextDate("");
      setSelectedServices([]);
      setIntervalMonths("");
      setIntervalKm("");
    } catch (error) {
      console.error(error);
      alert("Failed to schedule maintenance.");
    } finally {
      setLoading(false);
    }
  };
  
    const [categories, setCategories] = useState([]);
       const [errors, setErrors] = useState(null);
  const [services, setServices] = useState([]);
     
    
    const [selectedService, setSelectedService] = useState([]); // New state for selected service
    const [expandedCategoryId, setExpandedCategoryId] = useState(null); // Track which category is expanded
  const handleCategoryChange = async (category) => {
    const categoryId = category.servicecategoryID;

    // If the clicked category is already expanded, close it
    if (expandedCategoryId === categoryId) {
        setExpandedCategoryId(null);
        setServices([]); // Clear services if category is collapsed\
       // setSelectedService([]); // Reset selected service when collapsing
    } else {
        setExpandedCategoryId(categoryId);
        // Fetch services related to the selected category
        try {
            const response = await axios.get(`https://subk.education.com.ly/back/api/ServiceCategory/${categoryId}`); // Adjust your API endpoint accordingly
            setServices(response.data); // Assuming the API returns an array of services
        } catch (error) {
            console.error('Error fetching services:', error);
        }
    } 
   
};
const handleServiceSelect = (service) => {
  setSelectedService((prevSelectedService) => {
      // Check if the service is already selected
      const isSelected = prevSelectedService.some(selected => selected.ServiceID === service.ServiceID);
      
      if (isSelected) {
          // Remove the service from selected services
          return prevSelectedService.filter(selected => selected.ServiceID !== service.ServiceID);
      } else {
          // Add the service to selected services
          return [...prevSelectedService, service];
      }
  });
  console.log(selectedService)

};
 return (
  <Modal 
    show={inviteModal} 
    style={{ width: '750px', marginLeft: "200px" }} 
    size="xl" 
    centered
  >
    <div className="modal-content">
      {/* Modal Header */}
      <div className="modal-header">
        <h1 className="modal-title fs-5">جدولة الصيانة القادمة</h1>
        <button 
          type="button" 
          className="btn-close" 
          style={{ marginLeft: 0 }}  
          onClick={() => setInviteModal(false)}
        ></button>
      </div>

      {/* Modal Form */}
      <form onSubmit={handleSubmit} className="space-y-4 p-3">
        
        {/* Next Maintenance Date */}
      <div className="d-flex gap-2 mt-3">
  {/* Next Maintenance Date */}
  <div className="flex-1">
    <label className="block font-medium mb-1"> تاريخ الصيانة القادم</label>
    <input
      type="date"
      value={nextDate}
      onChange={(e) => setNextDate(e.target.value)}
      className="w-full p-2 border rounded"
      required
    />
  </div>

  {/* Interval (Months) */}
  <div className="flex-1">
    <label className="block font-medium mb-1">الفترة (بالأشهر)</label>    <input
      type="number"
      value={intervalMonths}
      onChange={(e) => setIntervalMonths(e.target.value)}
      className="w-full p-2 border rounded"
      min="0"
    />
  </div>

  {/* Interval (Km) */}
  <div className="flex-1">
    <label className="block font-medium mb-1">الفترة (بالكيلومترات)</label>    <input
      type="number"
      value={intervalKm}
      onChange={(e) => setIntervalKm(e.target.value)}
      className="w-full p-2 border rounded"
      min="0"
    />
  </div>
</div>

        {/* Services Selection */}
        <div className="row">
          {/* Categories and Services List */}
          <div className="col-xl-6 mt-2">
            <h6>تصنيفات الخدمات</h6>
            <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
              {categories.map(category => (
                <div key={category.servicecategoryID}>
                  {/* Category Header */}
                  <div
                    onClick={() => handleCategoryChange(category)}
                    style={{ 
                      cursor: 'pointer',
                      margin: '10px 0',
                      padding: '10px',
                      border: '1px solid #ccc',
                      background: expandedCategoryId === category.servicecategoryID 
                        ? 'rgba(80, 84, 94, 1)' 
                        : 'rgba(151, 174, 224, 1)',
                      color: '#fff'
                    }}
                  >
                    {category.categoryName}
                  </div>

                  {/* Services in Category */}
                  {expandedCategoryId === category.servicecategoryID && services.length > 0 && (
                    <div style={{ padding: '10px', border: '1px solid #ccc', marginBottom: '10px', backgroundColor: '#1c4c49' }}>
                      {services.map(service => (
                        <div 
                          key={service.ServiceID} 
                          className="service-details" 
                          style={{ 
                            margin: '5px 0',
                            cursor: 'pointer',
                            background: selectedService.some(selected => selected.ServiceID === service.ServiceID) 
                              ? '#d1e7dd' 
                              : '#fff',
                            padding: '5px',
                            border: '1px solid #ccc',
                            display: 'flex',
                            alignItems: 'center'
                          }}
                        >
                          <input 
                            type="checkbox"
                            checked={selectedService.some(selected => selected.ServiceID === service.ServiceID)}
                            onChange={() => handleServiceSelect(service)}
                          />
                          <strong style={{ marginLeft: '5px' }}>{service.ServiceName}</strong>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Selected Services Summary */}
          <div className="col-xl-6 mt-2">
            {selectedService.length > 0 ? (
              <div style={{ marginTop: '20px', padding: '10px', border: '1px solid #ccc' }}>
                <h4>الخدمات المختارة:</h4>
                {selectedService.map(service => (
                  <div key={service.ServiceID}>
                    <strong>{service.ServiceName}</strong>
                  </div>
                ))}
              </div>
            ) : (
              expandedCategoryId && services.length === 0 && (
                <p style={{ marginTop: '20px' }}>لا توجد خدمات لهدا التصنيف</p>
              )
            )}
          </div>
        </div>

        {/* Optional Recurrence Inputs */}
      
        {/* Submit Button */}
        <button
          type="submit"
          style={{float:'left'}}
          className="btn btn-primary"
          disabled={loading}
        >
          {loading ? "جاري الحفظ..." : "حفظ"}
        </button>
      </form>
    </div>
  </Modal>
);

});
export default CreateVehicleRepairRecord;
